// extracted by mini-css-extract-plugin
export default {"auto_search":"index_auto_search_OF6jl clearfix","text":"index_text_G5SmY","btn":"index_btn_GE-bD"};